export const TRAVEL_PASS_URL = 'https://cosmote.go.link/TravelPassService';
export const ROAMING_SHOP_URL = 'https://cosmote.go.link/ShopRoaming';
